module.exports = __webpack_public_path__ + "images/file_icons_v2/sketch-1a70f391f4ff228e52c75e905ee9a9bd.svg";